define('app/sss/wrap/sss-wrap-factory',["$injector"], function ($injector) {
	"use strict";
	var $original = "$original";
	return sssWrapFactory;
	function sssWrapFactory(original, wrapping) {
		var annotations;
		annotations = angular.extend(annotations = {
			original: $injector.annotate(original, true),
			wrappingFull: $Injector.annotate(wrapping, true)
		}, {
			wrapping: annotations.originalWrapping.filter(notOriginal),
			combined: annotations.original.concat(annotations.wrapping)
		});
		return angular.extend(returnFn, original, {
			$inject: annotations.combined
		})

		function prepareOriginalInvoke(context, args) {
			var locals = {};
			angular.forEach(annotations.original, function (name, i) {
				locals[name] = args[i + annotations.wrapping.length];
			});
			function invoke() {
				return $injector.invoke(original, context, locals);
			}
		}
		function returnFn() {
			var locals = {};
			angular.forEach(annotations.wrapping, function (name, i) {
				locals[name] = arguments[i];
			});
			locals[$original] = prepareOriginalInvoke(this, arguments);
			$injector.invoke(wrapping, this, locals);
		}
		function noWrapReturnFn() {

		}
	}
	function notOriginal(annotation) {
		return annotation !== $original;
	}
});
